module.exports = __webpack_public_path__ + "res/fontawesome-webfont.woff?fee66e712a8a08eef5805a46892932ad";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 13
// module chunks = 0